/**
 * fixed error to handle these values
 * 'https://booking.minu.synlab.ee/selfservice/orders-bookings/'
 * 'en|https://booking.minu.synlab.ee/selfservice/orders-bookings'
 */
export function getValidUrl(input: string): URL | null {
  try {
    if (input.includes('|')) {
      const [, urlPart] = input.split('|');
      return new URL(urlPart);
    }
    return new URL(input);
  } catch (err) {
    console.error('Invalid URL:', input);
    return null;
  }
}

export const hasLangCodeParam = (url: string): boolean => {
  try {
    const urlObj = getValidUrl(url);
    return urlObj.searchParams?.has('langCode');
  } catch (e) {
    console.error('Invalid URL:', e);
    return false;
  }
};
